import React from "react";
import { Link } from "react-router-dom";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { SectionHeading } from "components/misc/Headings";

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10`;
const Text = styled.div`
  ${tw`text-lg  text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  a {
    ${tw`underline text-blue-600 hover:text-blue-800 visited:text-purple-600`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ol {
    ${tw`list-decimal list-outside ml-5`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;
export default ({ headingText = "プライバシーポリシー" }) => {
  return (
    <AnimationRevealPage>
      <Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>{headingText}</Heading>
          </HeadingRow>
          <Text>
            <p>
              鎌倉情報技術株式会社（以下、「当社」といいます。）は、VTuber Life（以下、「本アプリ」といいます。）における、
              利用者情報および個人情報（以下、「個人情報」といいます。）の取り扱いについて、以下の通りプライバシーポリシー（以下、「本ポリシー」といいます。）を定めます。
              本アプリを利用するすべてのユーザー（以下、「ユーザー」といいます。）は、本ポリシーに同意した上で本アプリをご利用ください。
            </p>

            <h2>1. 収集する情報</h2>
            <p>
              本アプリでは、ユーザーが本アプリを利用する際に、以下の情報を収集します。
            </p>
            <ol>
              <li>アプリの利用状況</li>
              <li>デバイス情報（IPアドレス、デバイスID等）</li>
              <li>アプリ利用時のおおよその位置情報</li>
              <li>アプリのパフォーマンスデータおよびクラッシュデータ</li>
            </ol>
            <h2>2. 個人情報の利用</h2>
            <p>当社が個人情報を収集・利用する目的は下記の通りです。</p>
            <ol>
              <li>本アプリの提供・運営および改善のため</li>
              <li>本アプリの利用状況の調査および分析のため</li>
              <li>本アプリにおける広告の配信および表示のため</li>
              <li>上記の利用目的に付随する目的のため</li>
            </ol>
            <h2>3. 個人情報の第三者提供</h2>
            <p>当社は、以下の各号に定める場合を除き、ユーザーの個人情報を開示いたしません。</p>
            <ol>
              <li>ユーザーの事前の同意・承諾を得た場合</li>
              <li>法令等に基づき開示を求められた場合</li>
              <li>当社、その他の第三者等の権利、財産等を保護するために当社が個人情報を開示せざるをえないと判断した場合</li>
            </ol>
            <h2>4. プライバシーポリシーの変更</h2>
            <ol>
              <li>本ポリシーの内容は、法令に定めのある事項を除いて、ユーザーに通知することなく、変更できるものとします。</li>
              <li>法令に定めのある事項の変更を行なった場合には、当社所定の方法によりユーザーに通知し、また本ウェブサイト上に公表するものとします。</li>
              <li>当社が別途定める場合を除いて、変更後のプライバシーポリシーは、本ウェブサイトに掲載した時点から効力を生じるものとします。</li>
            </ol>

            <h2>5. お問い合わせ窓口</h2>
            <p>本ポリシーに関するお問い合わせは、当社ウェブサイトの<a href="/#contact">お問い合わせページ</a>までお願いいたします。</p>
          </Text>
        </ContentWithPaddingXl>
      </Container>
    </AnimationRevealPage>
  );
};
